module.exports = __webpack_public_path__ + "static/media/Logo-EarthID-white.a852c8f7.png";